import { NgTemplateOutlet } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject, TemplateRef } from '@angular/core'
import { TOOLTIP_DATA } from '../../directives/tooltip.directive'

@Component({
	imports: [NgTemplateOutlet],
	templateUrl: './tooltip-container.component.html',
	styleUrl: './tooltip-container.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipContainerComponent {
	get asString(): string | false {
		return typeof this.tooltipData === 'string' ? this.tooltipData : false
	}

	get asTemplate(): TemplateRef<void> | false {
		return this.tooltipData instanceof TemplateRef ? this.tooltipData : false
	}

	tooltipData = inject(TOOLTIP_DATA)
}
